/** * @description 打卡地址 * @author daxiong */
<template>
  <div id="clockAddress">
    <div class="add-group">
      <van-cell>
        <template #title>
          <div class="cell-add" @click="isShowAddressPopup = true">
            <van-icon name="add-o" />
            <span class="custom-title">添加地址</span>
          </div>
        </template>
      </van-cell>
    </div>

    <div
      class="address-item"
      v-for="(item, index) in condition.punchCardPlaceVos"
      :key="index"
    >
      <div class="title">{{ item.placeName || '-' }}</div>
      <div class="info">{{ item.address || '-' }}</div>
      <div class="info">允许正常打卡范围：{{ item.ranges }}米以内</div>
      <div class="close-btn" @click="deleteAddress(index)">
        <van-icon name="close" />
      </div>
    </div>

    <div class="confirm-btn" @click="confirmClick">
      <van-button type="info" class="confirm">确认</van-button>
    </div>

    <van-popup position="right" class="max-popup" v-model="isShowAddressPopup">
      <addressMap @getPoint="getPoint"></addressMap>
    </van-popup>
  </div>
</template>

<script>
import addressMap from '../lishui/components/addressMap'
export default {
  props: ['echoParam'],
  components: {
    addressMap
  },
  data() {
    return {
      isShowAddressPopup: false,
      condition: {
        punchCardPlaceVos: []
      }
    }
  },
  computed: {},
  watch: {
    echoParam: {
      deep: true,
      handler(val) {
        if (val && this.$route.path.includes('/groupEditor')) {
          this.condition = val
        }
      }
    }
  },
  methods: {
    deleteAddress(index) {
      this.condition.punchCardPlaceVos = [
        ...this.condition.punchCardPlaceVos.slice(0, index),
        ...this.condition.punchCardPlaceVos.slice(index + 1)
      ]
    },

    confirmClick() {
      console.log(this.condition)
      this.$emit('closePopupByAddress', this.condition)
    },

    getPoint(params) {
      this.isShowAddressPopup = false
      this.condition.punchCardPlaceVos.push(params)
      // let nameList =  [...new Set(this.condition.punchCardPlaceVos.map(v => v.placeName))]
    }
  },
  created() {
    if (this.echoParam && this.$route.path.includes('/groupEditor')) {
      this.condition = this.echoParam
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
#clockAddress {
  height: 100%;
  background: #f7f7f7;
  box-sizing: border-box;
  padding-top: 0.1px;
  .add-group {
    margin: 8px 0;
  }

  .max-popup {
    width: 100%;
    height: 100%;
  }

  ::v-deep .van-cell {
    &__title {
      .cell-add {
        display: flex;
        align-items: center;
        color: #0091ff;
        i {
          margin-right: 5px;
        }
      }
    }
  }

  .address-item {
    background: #fff;
    padding: 15px 15px 20px 15px;
    position: relative;
    font-family: PingFangSC-Medium;

    .title {
      color: #333;
      font-size: 16px;
      margin-bottom: 4px;
    }
    .info {
      color: #999;
      font-size: 14px;
    }

    .close-btn {
      width: 18px;
      height: 18px;
      font-size: 18px;
      color: #999;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
    }
  }

  .confirm-btn {
    box-sizing: border-box;
    width: 100%;
    height: 75px;
    background: #fff;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    .confirm {
      width: 100%;
      height: 40px;
    }
  }
}
</style>
